import { reportUserVisitAction, reportLog } from '../http/reporter';

import { userVisitData, UserAction, UserVisitPageAction, UserClickAction, UserLogAction } from '../types';

let currentApp: string | null = null;
let currentPage: string | null = null;
let userVisitCache: {
    [key: string]: number;
} | null = {};
let timer: number | null = null;

export function collectVisit(): void {
    initEventListener();
    initTimer();
}

function initEventListener() {
    window.addEventListener('load', function () {
        document.body.addEventListener(
            'click',
            function (ev) {
                if (!ev.target) return;
                let el = ev.target as Element;
                let actionCode: string | null = null;
                while (el.parentElement) {
                    if (el.getAttribute('isc-report')) {
                        actionCode = el.getAttribute('isc-report') as string;
                        break;
                    }
                    el = el.parentElement;
                }

                if (actionCode) {
                    record({ type: 'click', actionCode: actionCode });
                }
            },
            true
        );
    });
}

function initTimer() {
    timer = setInterval(() => {
        reportVisitAction();
    }, 10000);
}

function reportVisitAction() {
    let key;
    const reqBody: Array<userVisitData> = [];
    if (!userVisitCache) userVisitCache = {};
    for (key in userVisitCache) {
        reqBody.push({
            uri: key,
            count: userVisitCache[key]
        });
    }
    if (reqBody.length === 0) return;
    reportUserVisitAction(reqBody);

    utils.clear();
}

export function record(action: UserAction): void {
    if (!timer) {
        collectVisit();
    }
    if (action.type === 'visit') {
        recordVisit(action);
    } else if (action.type === 'click') {
        recordClick(action);
    } else if (action.type === 'log') {
        recordLog(action);
    }
}

function recordVisit(visitAction: UserVisitPageAction) {
    utils.updateCurrentState(visitAction);
    utils.updateVisitCache(utils.computeCode(visitAction));
}

function recordClick(action: UserClickAction) {
    // const code = currentApp + '|' + currentPage + '|' + action.actionCode;
    if (!currentApp) {
        return;
    }

    const code = `${currentApp}|${currentPage || 'default'}|${action.actionCode}`;
    utils.updateVisitCache(code);
}

function recordLog(userLogData: UserLogAction) {
    const appCode = utils.getAppCode();
    const content = utils.computeLogContent(userLogData);
    const reqBody = [
        {
            logFile: userLogData.logTag,
            app: appCode,
            logs: [content]
        }
    ];

    reportLog(reqBody);
}

const utils = {
    computeCode: function (visitAction: UserVisitPageAction) {
        // 0 代表 actionCode 没有
        return visitAction.appCode + '|' + visitAction.pageCode + '|' + '0';
    },

    computeLogContent: function (userLogData: UserLogAction) {
        let content = userLogData.content.replaceAll(/｜/g, '|');
        if (content.indexOf('|') === 0) content = content.substring(1);

        const userName = '${user}';
        const time = '${time}';

        return time + '|' + userName + '|' + utils.getAppCode() + '|' + content;
    },

    getAppCode: function () {
        const pathParts = location.pathname.split('/');
        if (!pathParts.length) return 'unknown';
        return pathParts[pathParts.length - 1];
    },

    updateVisitCache: function (code: string) {
        if (!userVisitCache) userVisitCache = {};
        if (!userVisitCache[code]) {
            userVisitCache[code] = 1;
        }

        userVisitCache[code] = userVisitCache[code] + 1;
    },

    updateCurrentState: function (visitAction: UserVisitPageAction) {
        currentApp = visitAction.appCode;
        currentPage = visitAction.pageCode;
    },

    clear() {
        userVisitCache = null;
    }
};
